module.exports = __webpack_public_path__ + "static/media/wise_logo.1e58cda9.svg";